import { render, staticRenderFns } from "./allModulesPainel.vue?vue&type=template&id=558c5878&scoped=true&"
import script from "./allModulesPainel.vue?vue&type=script&lang=js&"
export * from "./allModulesPainel.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=558c5878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c5878",
  null
  
)

export default component.exports